export default (customer, states, errors = []) => ({
    customer,

    init() {
        this.handleError(errors);

        this.$dispatch('customer-updated', this.customer);

        if (this.$store.cart.hasNotDigitalItems()) {
            this.$wire.set('requiresAddress', true);

            if (this.$store.cart.mainEvent.delivery_type === 'Ship Only') {
                this.$wire.set('order.ship', true);
            }
        }
    },

    handleError(errors) {
        if (errors.length === 0 && '{{ $this->step->name }}' === 'payment') {
            return;
        }

        document.getElementById('step::form').scrollIntoView({ behavior: 'smooth' });
    },

    disabled() {
        return (
            this.customer.default_payment_method == null ||
            this.customer.email == null ||
            this.customer.first_name == null ||
            this.customer.last_name == null ||
            this.customer.phone == null ||
            this.$store.cart.items.length === 0
        );
    },

    stateAbbreviation(state) {
        for (var key in states) {
            states[states[key]] = key;
        }

        return states[state] ?? state;
    },
});
